import React, { useEffect, useState } from "react";
import { Menu, X, Facebook, Instagram } from "lucide-react";
import { navLinks, site } from "../mock";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";

const Logo = ({ dark }) => (
  <a href="#top" className="flex items-center gap-3 group">
    <svg width="38" height="38" viewBox="0 0 48 48" fill="none" className="shrink-0">
      <path d="M6 6h16a0 0 0 0 1 0 0v14a10 10 0 0 1-10 10H6a0 0 0 0 1 0 0V6Z" fill="#86233a" />
      <path d="M24 12a12 12 0 0 1 12 12 12 12 0 0 1-12 12V12Z" fill="#530e2f" />
    </svg>
    <div className="leading-tight">
      <div className={`font-display text-lg font-600 tracking-tight ${dark ? "text-[#530e2f]" : "text-[#530e2f]"}`} style={{ fontWeight: 600 }}>
        {site.name}
      </div>
      <div className="text-[10px] uppercase tracking-[0.25em] text-[#86233a]/80">
        {site.role}
      </div>
    </div>
  </a>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#fbfaf6]/95 backdrop-blur-md shadow-[0_2px_20px_rgba(83,14,47,0.08)] py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="relative text-sm font-500 text-[#1d1c1a] hover:text-[#86233a] transition-colors duration-200 after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#86233a] after:transition-all after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a href={site.socials.facebook} target="_blank" rel="noreferrer" className="text-[#530e2f] hover:text-[#86233a] transition-colors">
            <Facebook size={18} />
          </a>
          <a href={site.socials.instagram} target="_blank" rel="noreferrer" className="text-[#530e2f] hover:text-[#86233a] transition-colors">
            <Instagram size={18} />
          </a>
          <a
            href="#contact"
            className="ml-2 inline-flex items-center rounded-full bg-[#86233a] px-5 py-2.5 text-sm font-500 text-white hover:bg-[#530e2f] transition-colors duration-300 shadow-sm"
          >
            Plan je reis
          </a>
        </div>

        {/* Mobile */}
        <div className="lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button aria-label="Menu" className="p-2 text-[#530e2f]">
                <Menu size={26} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#fbfaf6] w-[80%] border-l border-[#e7ddcf]">
              <div className="flex flex-col gap-2 mt-8">
                {navLinks.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="font-display text-2xl text-[#530e2f] py-2 border-b border-[#efe6d8]"
                  >
                    {l.label}
                  </a>
                ))}
                <a
                  href="#contact"
                  onClick={() => setOpen(false)}
                  className="mt-6 inline-flex justify-center items-center rounded-full bg-[#86233a] px-6 py-3 text-white font-500"
                >
                  Plan je reis
                </a>
                <div className="flex gap-5 mt-6">
                  <a href={site.socials.facebook} className="text-[#530e2f]"><Facebook /></a>
                  <a href={site.socials.instagram} className="text-[#530e2f]"><Instagram /></a>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
